import { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useRegisterTenant } from '@/hooks/useRegistration'
import { useToast } from '@/hooks/use-toast'

export default function RegisterPage() {
  const { toast } = useToast()
  const registerMutation = useRegisterTenant()
  const [form, setForm] = useState({
    tenantName: '',
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    businessType: '',
    expectedMonthlyVolume: '' as unknown as number,
    description: '',
  })

  const handleChange = (field: string, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      await registerMutation.mutateAsync({
        tenantName: form.tenantName,
        contactName: form.contactName,
        contactPhone: form.contactPhone,
        contactEmail: form.contactEmail,
        businessType: form.businessType || undefined,
        expectedMonthlyVolume: form.expectedMonthlyVolume ? Number(form.expectedMonthlyVolume) : undefined,
        description: form.description || undefined,
      } as any)
      toast({ title: '注册成功', description: '我们已收到您的注册信息，请等待审核或继续完成认证。' })
      setForm({ tenantName: '', contactName: '', contactPhone: '', contactEmail: '', businessType: '', expectedMonthlyVolume: '' as any, description: '' })
    } catch (err: any) {
      toast({ title: '注册失败', description: err?.message || '请稍后再试', variant: 'destructive' })
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-6">
      <Card className="w-full max-w-xl shadow-lg">
        <CardHeader>
          <CardTitle>企业租户注册</CardTitle>
          <CardDescription>提交您的企业信息以申请开通租户账号</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="tenantName">企业名称 *</Label>
                <Input id="tenantName" value={form.tenantName} onChange={(e) => handleChange('tenantName', e.target.value)} required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="contactName">联系人姓名 *</Label>
                <Input id="contactName" value={form.contactName} onChange={(e) => handleChange('contactName', e.target.value)} required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="contactPhone">联系电话 *</Label>
                <Input id="contactPhone" value={form.contactPhone} onChange={(e) => handleChange('contactPhone', e.target.value)} required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="contactEmail">联系邮箱 *</Label>
                <Input id="contactEmail" type="email" value={form.contactEmail} onChange={(e) => handleChange('contactEmail', e.target.value)} required />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="businessType">业务类型</Label>
                <Input id="businessType" value={form.businessType} onChange={(e) => handleChange('businessType', e.target.value)} />
              </div>
              <div className="space-y-2">
                <Label htmlFor="expectedMonthlyVolume">预期月发送量</Label>
                <Input id="expectedMonthlyVolume" type="number" value={form.expectedMonthlyVolume as any} onChange={(e) => handleChange('expectedMonthlyVolume', e.target.value)} />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="description">备注</Label>
              <Input id="description" value={form.description} onChange={(e) => handleChange('description', e.target.value)} />
            </div>
            <Button type="submit" className="w-full" disabled={registerMutation.isPending}>
              {registerMutation.isPending ? '提交中...' : '提交注册'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}


